import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

export type OwnProps = {
  stripeSettingId: number
  onClose: () => void
}

const mapStateToProps = (state: ReduxState, ownProps: OwnProps) => {
  return {
    isLoading: selectors.isLoadingSelector(state, 'isUpdateStripeSetting'),
    stripeSetting: selectors.stripeSettingSelector(state, ownProps.stripeSettingId)
  }
}

const mapDispatchToProps = {
  updateStripeSetting: actions.updateStripeSetting
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
